// Router.js
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from '../App';
import Ai from '../pages/aiExperience/Ai'; // 假设你有这个页面

function Router() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/ai" element={<Ai />} />
            </Routes>
        </BrowserRouter>
    );
}

export default Router;
